import React, { Component } from 'react';

import BackgroundImage from './background-image';
import Footer from '../../containers/footer.container';
import GroupSummary from '../../containers/purchase-dashboard/group-summary/index';
import OrganizerControls from '../../containers/purchase-dashboard/organizer-controls.container';
import PurchaseDashboardBody from '../../containers/purchase-dashboard/dashboard-body.container';
import TopNavBar from '../../containers/top-nav-bar.container';
import Confettiful from '../../../vendor/confettiful';

import AlertsContainer from '../../containers/purchase-dashboard/alerts.container';
import ModalsContainer from '../../containers/purchase-dashboard/modals.container';
import SignupModal from '../signup-modal';
import SigninModal from '../signin-modal';
import PasswordResetModal from '../password-reset-modal';

import Purchase from '../../lib/purchase';

import '../../css/purchase-dashboard.css';
import '../../css/confettiful.css';

class PurchaseDashboard extends Component {
  componentDidUpdate() {
    this.triggerConfettiEffect();
  }

  triggerConfettiEffect() {
    const { purchase } = this.props;

    if (Purchase.isCompleted(purchase) && !this.confettiful) {
      this.confettiful = new Confettiful(document.body);
    }
  }

  render() {
    const { purchase } = this.props;

    return (
      <div className="purchase-dashboard-page">
        <BackgroundImage
          images={purchase.product.images}
          defaultImageUrl={purchase.product.defaultImageUrl}
        />
        <TopNavBar />
        <div className="container purchase-dashboard">
          <AlertsContainer />
          <div className="mt-4">
            <OrganizerControls />
          </div>
          <div className="purchase-dashboard-sidebar sticky-top flex-last">
            <GroupSummary />
          </div>
          <div className="purchase-dashboard-body flex-first">
            <PurchaseDashboardBody />
          </div>
          <div className="clearfix" />
        </div>
        <Footer />
        <ModalsContainer />
        <SigninModal />
        <SignupModal />
        <PasswordResetModal />
      </div>
    );
  }
}

export default PurchaseDashboard;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/index.js